import { UpdateIntervalOption } from '@kcftech/prometheustypescriptapiclient';
import { useMutation } from '@tanstack/react-query';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsMaxUpdateIntervalProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationFastestVibrationUpdateCell({
    rowData,
    onChange,
    options,
}: LocationsMaxUpdateIntervalProps) {
    const { canEditLocationDetails } = usePermissions();
    const selectedOption = options.find(
        (option) => option.Value === rowData.Settings.MaxVibrationUpdateInterval
    );
    const { showToast } = useNotificationContext();
    const { mutate: updateMaxVibration, isPending } = useMutation({
        mutationFn: (maxVibrationUpdate: UpdateIntervalOption | undefined) =>
            updateLocation(rowData, {
                MaxVibrationUpdateInterval: maxVibrationUpdate?.Value as number,
            }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location fastest vibration update interval',
            }),
    });

    return (
        <DropdownInlineEditor
            options={options}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.Description,
                dataKey: (item) => item.Value,
                renderItem: ({ item }) => item.Description,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.Description}
            onConfirm={updateMaxVibration}
            isDisabled={isPending || !canEditLocationDetails}
        />
    );
}
